import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {PagedResponse, ProcessoExecucao, ProcessoExecucaoDetalhe, ProcessoFiltro} from "../types/ProcessoExecucao.type";

@Injectable({
  providedIn: 'root'
})
export class ProcessoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getProcessos(filtro: ProcessoFiltro, page: number, size: number, sort?: string) {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (filtro.servico) params = params.set('servico', filtro.servico);
    if (filtro.processo) params = params.set('processo', filtro.processo);
    if (sort) params = params.set('sort', sort);

    return this.httpClient.get<PagedResponse<ProcessoExecucao>>(`${this.configService.getApiUrlRoot()}/processos/`, { params });
  }

  getProcesso(id: string) {
    return this.httpClient.get<ProcessoExecucaoDetalhe>(`${this.configService.getApiUrlRoot()}/processos/${id}`);
  }
}
